export default import.meta.ROLLUP_FILE_URL_oByUS_0W6gO9XT$rKDrs4Q